<template>
  <div class="change-history">
    <v-skeleton-loader v-if="isLoading" type="list-item-three-line@5" />
    <template v-else>
      <div>
        <historyItem
          v-for="(item, index) in changes"
          :currentVersion="index === 0"
          :item="item"
          :key="item.Version"
          :selected="index === 0"
          @editChange="editChange"
          @restoreChange="restoreChange"
          @promote="promote"
        />
      </div>
      <qvoButton
        text
        class="show-more"
        v-if="showChangeButton"
        @click="showMoreSelected = true"
        >Show More</qvoButton
      >
    </template>
  </div>
</template>
  
<script>
/**
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

const SHOW_CHANGE_BUTTON_THRESHOLD = 20;

import { mapGetters } from "vuex";

import qvoButton from "@/qux-common/qux22/components/molecules/button";
import historyItem from "./history-item";

export default {
  name: "ChangeHistory",
  components: {
    historyItem,
    qvoButton,
  },
  data() {
    return {
      selectedVersion: null,
      showMoreSelected: false,
    };
  },
  methods: {
    fetchList() {
      this.$store.dispatch("changeList", { ClientId: this.activeTab.ClientId });
    },
    editChange(args) {
      this.$store.dispatch("editChange", {
        ClientId: this.activeTab.ClientId,
        ...args,
      });
    },
    restoreChange(args) {
      this.$store.dispatch("restoreChange", {
        ClientId: this.activeTab.ClientId,
        ClientInfoRuleId: this.activeTab.ClientInfoRuleId,
        ...args,
      });
    },
    promote() {
      this.$store.dispatch("startPromote", {
        clients: [
          {
            clientId: this.activeTab.ClientId,
            clientInfoRuleId: this.activeTab.ClientInfoRuleId,
          },
        ],
      });
    },
  },
  computed: {
    isLoading() {
      return this.pendingCalls.includes("/client/change/list");
    },
    showChangeButton() {
      return (
        this.changeList.length > SHOW_CHANGE_BUTTON_THRESHOLD &&
        !this.showMoreSelected
      );
    },
    changes() {
      return this.showChangeButton
        ? this.changeList.slice(0, SHOW_CHANGE_BUTTON_THRESHOLD)
        : this.changeList;
    },
    ...mapGetters({
      changeList: "getChangeList",
      clientData: "getChangeHistoryClientData",
      pendingCalls: "getPendingCallList",
      activeTab: "getActiveTab",
    }),
  },
  mounted() {
    this.fetchList();
  },
  watch: {
    activeTab() {
      this.fetchList();
    },
  },
};
</script>
  
<style lang="scss" scoped>
.show-more.v-btn:not(.v-btn--round) {
  margin: $qvo-spacing-4;
  &:hover {
    background-color: unset;
  }
}
</style>